import APIClient from './index';
import _ from 'lodash';

export const getAllBrands = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AllBrands?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getAllBrandsByIds = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AllBrands/list?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getAllBrandsFilters = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AllBrands/filters?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateAllBrand = (brandId, brandData) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`AllBrands/${brandId}`, brandData)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const addAllBrand = brandData => {
  return new Promise((resolve, reject) => {
    APIClient.post('AllBrands', brandData)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const mergeAllBrands = mergeData => {
  return new Promise((resolve, reject) => {
    APIClient.post('AllBrands/merge', mergeData)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getAllBrandProducts = (brandId, options = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AllBrands/${brandId}/products`, { signal: options.signal })
      .then(response => resolve(response.data))
      .catch(err => {
        if (err?.name === 'AbortError') {
          reject(err);
        } else {
          reject(_.get(err, 'data.error'));
        }
      });
  });
};

export const getAllBrandProductCount = (brandId, domain = null) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AllBrands/${brandId}/products/count`, { params: { domain } })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const archiveAllBrand = (brandId, options) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`AllBrands/${brandId}/archive`, options)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
